import { createContext, use } from "react";
import type { AccessPermission } from "../api/types";
import { defined } from "../utilities/typeHelper";

interface ContextValue {
  permissions: AccessPermission[];
  permissionSets: { clientCode: string; permissions: AccessPermission[] }[];
  hasAnyPermission: (values: AccessPermission[]) => boolean;
  hasAnyPermissionForClient: (clientCode: string, values: AccessPermission[]) => boolean;
}

export interface Props {
  permissions: AccessPermission[];
  permissionSets: { clientCode: string; permissions: AccessPermission[] }[];
}

export const ClientPermissionsContext = createContext<ContextValue | undefined>(undefined);

export const useClientPermissionsContext = () => {
  const client = use(ClientPermissionsContext);
  return defined(client);
};
